export const orderTargetAudiencesKeys = [
  'KIDS',
  'CHILDREN',
  'TEENAGER',
  'ADULT',
  'ELDERLY',
];

export function sortByAudienceAge(a, b) {
  return (
    orderTargetAudiencesKeys.indexOf(a) - orderTargetAudiencesKeys.indexOf(b)
  );
}
